import { fetcher } from '@commenda/utils';

export async function linkCredential(
  businessEntityId: number,
  registrationId: string,
  credentialId: string
) {
  const response = await fetcher(
    `business-entities/${businessEntityId}/registrations/${registrationId}/credential/${credentialId}`,
    {
      method: 'POST',
    }
  );

  return response;
}
